export default {"src":"/_next/static/media/icon-checkmark-rounded.7e34c55e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};